const template = `
	<router-link v-if="!hidden" :to="to" class="period-nav-btn">
		<i v-if="direction === 'backward'" class="chevron-left zmdi zmdi-chevron-left"></i>
		{{ text }}
		<i v-if="direction === 'forward'" class="chevron-right zmdi zmdi-chevron-right"></i>
	</router-link>
`;

export default {
	template,
	props: [
		'val',
		'direction'
	],
	data() {
		return {
			range: null
		};
	},
	computed: {
		to() {
			let dates;

			if (!this.range) return '';

			if (this.range.format === 'month') {
				dates = this.newFromMoment.format('YYYY-MM');
			} else {
				dates = this.newFromMoment.format('YYYY-MM-DD') + '_' + this.newToMoment.format('YYYY-MM-DD');
			}

			return this.getExtendedQueryUrl({ dates });
		},
		today() {
			return moment().tz(this.app.tz).format('YYYY-MM-DD');
		},
		hidden() {
			if (!this.range) return true;
			return this.newToMoment.format('YYYY-MM-DD') > this.today;
		},
		days() {
			if (!this.range) return null;

			let mFrom = moment.tz(this.range.from, this.app.tz);
			let mTo = moment.tz(this.range.to, this.app.tz);
			return mTo.diff(mFrom, 'days') + 1;
		},
		newFromMoment() {
			if (!this.range) return null;

			let days = this.direction === 'backward' ? -this.days : this.days;
			return moment.tz(this.range.from, this.app.tz).add(days, 'days');
		},
		newToMoment() {
			if (!this.range) return null;

			let days = this.direction === 'backward' ? -this.days : this.days;
			return moment.tz(this.range.to, this.app.tz).add(days, 'days');
		},
		text() {
			if (!this.range) return;
			let from = this.getSibling(this.range.from);
			let to = this.getSibling(this.range.to);

			if (this.range.format === 'month') {
				return from.format('MMMM YYYY');
			}

			let fromDate = from.format('YYYY-MM-DD');
			let toDate = to.format('YYYY-MM-DD');
			let format = 'MMM D';

			if (fromDate === toDate) {
				if (toDate === this.today) return this.ii('TODAY');

				let daysAgo = moment().tz(this.app.tz).diff(moment.tz(toDate, this.app.tz), 'days');
				if (daysAgo === 1) return this.ii('YESTERDAY');

				return from.format(format);
			}

			return from.format(format) + ' - ' + to.format(format);
		}
	},
	methods: {
		update() {
			this.range = this.parseDateRange(this.val);
		},
		getSibling(date) {
			if (!this.range) return null;

			let dir = this.direction === 'backward' ? -1 : 1;

			if (this.range.format === 'month') {
				return moment.tz(date, this.app.tz).add(dir, 'months');
			}

			let days = this.days * dir;
			return moment.tz(date, this.app.tz).add(days, 'days');
		}
	},
	watch: {
		val() {
			this.update();
		}
	},
	mounted() {
		this.update();
	}
};